import moment from "moment";
import "moment/locale/ar";
import i18n, { Strings } from "INTL/i18n";
import { ARABIC } from "./constants";
import { toast } from "react-toastify";

/* for converting int into Date */
export function convertIntoDate(value, locale = i18n.language) {
  /* locale === "ar" ? moment.locale("ar") : */ moment.locale("en");
  let date;
  if (value !== null) {
    date = moment(value).format("DD MMM YYYY hh:mm A");
    return date;
  }
}
/* Get status name from Provided value */
export function findStatusNameFromValue(statusValue) {
  let status;

  let color = "red";
  switch (statusValue) {
    case "PAYMENT_GATEWAY_INITIALIZATION_STARTED":
      status = Strings("pending");
      color = "#00000f";
      break;
    case "PAYMENT_GATEWAY_INITIALIZATION_SUCCESS":
      status = Strings("initiated");
      color = "#00000f";
      break;
    case "ERROR":
      status = Strings("error");
      break;
    case "CAPTURED":
      status = Strings("success");
      color = "green";
      break;
    case "NOT_CAPTURED":
    case "MAXIMUM_RETRY_REACHED":
    case "PAYMENT_GATEWAY_INITIALIZATION_FAILURE":
      status = Strings("failed");
      break;
    case "PAYMENT_TOKEN_EXPIRED":
      status = Strings("expired");
      break;
    case "PAYMENT_LINK_OPENED":
      status = Strings("opened");
      color = "#00000f";
      break;
    default:
      status = Strings("failed");
  }
  return { name: status, color: color };
}

/* Get values from Status Name */
export function findNameFromKey(key) {
  return Strings(key);
}

/* Get values from Status Name */
export function findStatusValueFromName(statusName) {
  let status;
  switch (statusName) {
    case "pending":
      status = ["PAYMENT_GATEWAY_INITIALIZATION_STARTED"];
      break;
    case "initiated":
      status = ["PAYMENT_GATEWAY_INITIALIZATION_SUCCESS"];
      break;
    case "error":
      status = ["ERROR"];
      break;
    case "success":
      status = ["CAPTURED"];
      break;
    case "opened":
      status = ["PAYMENT_LINK_OPENED"]
      break;
    case "failed":
      status = [
        "NOT_CAPTURED",
        /*"PAYMENT_GATEWAY_INITIALIZATION_FAILURE",
        "MAXIMUM_RETRY_REACHED",*/
      ];
      break;
    case "expired":
      status = ["PAYMENT_TOKEN_EXPIRED"];
      break;
    default:
      status = ["NOT_CAPTURED"];
  }
  return status;
}
/* Convert Date to miliseconds */
export function convertDateToMiliseconds(d) {
  let gmtDate = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);
  let dateInMiliseconds = Date.parse(gmtDate);
  return dateInMiliseconds;
}
export function searchPlaceholder(locale = i18n.language) {
  if (locale === ARABIC) return "Filter Data AR";
  else return "Filter Data";
}
/* Mapping of number to Months */
export function convertNumberToMonthName(number) {
  let convertedMonth = "";
  switch (number) {
    case 1:
      convertedMonth = Strings("jan");
      break;
    case 2:
      convertedMonth = Strings("feb");
      break;
    case 3:
      convertedMonth = Strings("mar");
      break;
    case 4:
      convertedMonth = Strings("apr");
      break;
    case 5:
      convertedMonth = Strings("may");
      break;
    case 6:
      convertedMonth = Strings("jun");
      break;
    case 7:
      convertedMonth = Strings("jul");
      break;
    case 8:
      convertedMonth = Strings("aug");
      break;
    case 9:
      convertedMonth = Strings("sep");
      break;
    case 10:
      convertedMonth = Strings("oct");
      break;
    case 11:
      convertedMonth = Strings("nov");
      break;
    default:
      convertedMonth = Strings("dec");
      break;
  }
  return convertedMonth;
}
/* Validations for URL */
export function validateURL(url) {
  // let regEx=/^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
  // let regEx1 = new RegExp("^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i");

  /* Regular expression for validating URL */
  // let regEx = new RegExp("(https?:(?:www|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9][^]{2,}|www[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9][^]{2,}|https?:(?:www|(?!www))[a-zA-Z0-9][^]{2,}|www[a-zA-Z0-9][^]{2,})");
  // return regEx.test(url)

  return true;
}
/* Validations for File Folder Path*/

export function validateFolderPath(url) {
  let regEx = /^[a-z]:((\\|\/)[a-z0-9\s_@\-^!#$%&+={}])$/;

  // let regEx = new RegExp('^[a-z]:((\\\\|\/)[a-zA-Z0-9_ \-]+)$', 'i');
  // regex.test(str5);
  // let regEx=/^(?:[\w]\:|\\)(\\[a-z_\-\s0-9\.]+)$/i;
  return regEx.test(url);
}

/**
 * Check if toast is active or not .If toast is active then prevent from rendering it.
 */
export function isToastNotActive(toastId, errorMessage) {
  if (!navigator.onLine) errorMessage = "No network connection.";
  if (!toast.isActive(toastId)) {
    toast.error(errorMessage, {
      toastId: 1,
    });
  }
}
/* Parse access token for login */
export function parseToken() {
  let base64Url = localStorage
    .getItem("tokenPaymentApp_access_token")
    .split(".")[1];
  let base64 = base64Url.replace("-", "+").replace("_", "/");
  let parsedToken = JSON.parse(window.atob(base64));
  return parsedToken;
}
/* get current date */
export function getCurrentDateTime() {
  var today = new Date();
  moment.locale("en");
  let date;
  if (today !== null) {
    date = moment(today).format("YYYY-MM-DD hh:mm:ss A");
  }
  return date;
}
/* Get Browser Name */
export function getBrowserName(){
  var ua= navigator.userAgent, tem,
  M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if(/trident/i.test(M[1])){
      tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE '+(tem[1] || '');
  }
  if(M[1]=== 'Chrome'){
      tem= ua.match(/\b(OPR|Edge?)\/(\d+)/);
      if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');            
  }
  M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
  if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
  return M.join(' ');
}



// WEBPACK FOOTER //
// ./src/utils/commonUtiltyFunctions.js